import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { UserProfileApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseCommunicationUserSettings {
  id: number;
}

export const useCommunicationUserSettings = ({
  id,
}: IUseCommunicationUserSettings) => {
  const accessToken = useAccessToken();

  const { data, isSuccess, isError, isPending, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.CommunicationSettings, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(UserProfileApi, accessToken);
      return service.apiUserProfileIdSettingsGet({
        id,
      });
    },
    enabled: !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isSuccess,
    isError,
    isPending,
    isFetching,
    refetch,
  };
};
